import { cn } from "@lib/cn";
import { useLockedAction } from "../hooks";

const PLAN_STYLES = {
  container: {
    starter: "tw-bg-starter-background tw-border-starter-base/30",
    pro: "tw-bg-pro-background tw-border-pro-base/30",
    team: "tw-bg-team-background tw-border-team-base/30",
  },
  limit: {
    starter: "tw-bg-starter-base/30",
    pro: "tw-bg-pro-base/30",
    team: "tw-bg-team-base/30",
  },
  limitBar: {
    starter: "tw-bg-starter-base",
    pro: "tw-bg-pro-base",
    team: "tw-bg-team-base",
  },
  text: {
    starter: "tw-text-starter-base",
    pro: "tw-text-pro-base",
    team: "tw-text-team-base",
  },
};

const LiveVersionsLimit = ({ count }: { count: number }) => {
  const { value: limit, plan } = useLockedAction({
    feature: "live-versions",
  });
  if (typeof limit !== "number") return null;

  return (
    <div
      className={cn(
        "tw-ml-2 tw-flex tw-items-center tw-rounded-lg tw-border tw-border-solid tw-bg-starter-background tw-px-2 tw-py-1",
        PLAN_STYLES.container[plan as keyof typeof PLAN_STYLES.container],
      )}
    >
      <div
        className={cn(
          "tw-mr-1 tw-h-[6px] tw-w-10 tw-overflow-hidden tw-rounded-lg",
          PLAN_STYLES.limit[plan as keyof typeof PLAN_STYLES.limit],
        )}
      >
        <span
          className={cn(
            "tw-block tw-h-full tw-rounded-lg",
            PLAN_STYLES.limitBar[plan as keyof typeof PLAN_STYLES.limitBar],
          )}
          style={{
            width: `${((count || 0) / limit) * 100}%`,
          }}
        ></span>
      </div>
      <span
        className={cn(
          "tw-font-sans tw-text-[10px]/normal tw-font-semibold tw-uppercase tw-tabular-nums",
          PLAN_STYLES.text[plan as keyof typeof PLAN_STYLES.text],
        )}
      >
        {count || 0}/{limit}
      </span>
    </div>
  );
};

export default LiveVersionsLimit;
